import React from 'react';
import { Link } from 'react-router-dom';
import {
  DocumentChartBarIcon,
  ChartBarIcon,
  ClockIcon,
  CpuChipIcon,
} from '@heroicons/react/24/outline';
import { useUser } from '../contexts/UserContext';

const Reports = () => {
  const { isAdmin } = useUser();

  const reportItems = [
    {
      name: 'Executive Summary',
      description: 'Comprehensive overview of SLA, churn, and category metrics with insights',
      href: '/executive-summary',
      icon: DocumentChartBarIcon,
      color: 'bg-indigo-600'
    },
    {
      name: 'SLA Reports',
      description: 'View Service Level Agreement performance and compliance metrics',
      href: '/sla-report',
      icon: ChartBarIcon,
      color: 'bg-blue-500'
    },
    {
      name: 'Ticket Churn Report',
      description: 'Analyze ticket creation and resolution patterns over time',
      href: '/ticket-churn-report',
      icon: ClockIcon,
      color: 'bg-green-500'
    },
    {
      name: 'Ticket Category Breakdown',
      description: 'Analyze ticket distribution across different categories with charts and tables',
      href: '/ticket-category-breakdown',
      icon: DocumentChartBarIcon,
      color: 'bg-purple-500'
    },
    ...(isAdmin() ? [{
      name: 'Claude Usage',
      description: 'Monitor AI usage, costs and activity across the team',
      href: '/claude-usage',
      icon: CpuChipIcon,
      color: 'bg-violet-500'
    }] : []),
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
        <p className="text-gray-600">View and analyze helpdesk performance metrics and reports</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reportItems.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className="block group"
          >
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow h-32 flex items-center">
              <div className="flex items-center space-x-4 w-full">
                <div className={`${item.color} p-3 rounded-lg flex-shrink-0`}>
                  <item.icon className="h-6 w-6 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-medium text-gray-900 group-hover:text-blue-600 transition-colors">
                    {item.name}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Reports; 